var register = {
  parts: ["label", "helpText", "number", "container", "icon"],
  sizes: ["sm", "md", "lg"]
};
var baseStyle = {
  container: {
    flex: "1",
    paddingRight: 4
  },
  label: {
    fontWeight: "medium"
  },
  helpText: {
    opacity: 0.8,
    marginBottom: 2
  },
  number: {
    verticalAlign: "baseline",
    fontWeight: "semibold"
  },
  icon: {
    marginRight: 1,
    width: "14px",
    height: "14px",
    verticalAlign: "middle"
  }
};
var sizes = {
  md: {
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  }
};
var defaultProps = {
  size: "md"
};
var stat = {
  register,
  defaultProps,
  baseStyle,
  sizes
};
export default stat;
//# sourceMappingURL=stat.js.map